
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"d":"M21.688 5.273c.234.235.39.547.39.899V15c0 1.406-1.133 2.5-2.5 2.5h-7.5c-1.406 0-2.5-1.094-2.539-2.5V5c0-1.367 1.094-2.5 2.5-2.5h6.367c.352 0 .664.156.899.39l2.383 2.383zM20.203 15h-.039V7.5h-1.836c-.703 0-1.25-.547-1.25-1.25l-.039-1.836h-5a.617.617 0 00-.625.625V15c0 .352.274.625.625.625h7.54a.642.642 0 00.624-.625zm-7.5 5v-1.25h1.875V20c0 1.406-1.133 2.5-2.5 2.5h-7.5a2.468 2.468 0 01-2.5-2.5L2.04 10c0-1.367 1.133-2.5 2.5-2.5h3.79v1.914H4.54a.642.642 0 00-.625.625V20c0 .352.273.625.625.625h7.54a.642.642 0 00.624-.625z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      